import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@hotjar/hotsauce';

import { useIntegrations } from '../../hooks/use-integrations';
import { EnableMsTeamsModal, DisableMsTeamsModal } from '../MsTeamsModals';

interface MsTeamsActionsProps {
  siteId: string | null;
  siteName: string | null;
  actionLabel: Record<string, string>;
  isAdmin: boolean;
}

export const MsTeamsActions = ({
  siteId,
  siteName,
  actionLabel,
  isAdmin,
}: MsTeamsActionsProps): JSX.Element => {
  const [isConnected, setIsConnected] = useState(false);
  const [connectModalOpen, setConnectModalOpen] = useState(false);
  const [disconnectModalOpen, setDisconnectModalOpen] = useState(false);
  const { integrations } = useIntegrations(Number(siteId));
  const { t } = useTranslation();

  const { isEnabled = false } =
    integrations.find((integration) => integration.otterName === 'teams_webhook') ?? {};

  useEffect(() => {
    setIsConnected(isEnabled);
  }, [isEnabled]);

  const handleActionButtonClick = () => {
    if (!isConnected) {
      setConnectModalOpen(true);
    } else {
      setDisconnectModalOpen(true);
    }
  };

  return (
    <>
      <Button
        aria-label={!isConnected ? t(actionLabel.enable) : t(actionLabel.disable)}
        kind={!isConnected ? 'primary' : 'danger_secondary'}
        isDisabled={!isAdmin}
        onClick={handleActionButtonClick}
      >
        {!isConnected ? t(actionLabel.enable) : t(actionLabel.disable)}
      </Button>
      <EnableMsTeamsModal
        isOpen={connectModalOpen}
        onRequestClose={() => setConnectModalOpen(false)}
        onSuccess={() => setConnectModalOpen(false)}
        onError={() => setConnectModalOpen(false)}
        siteId={siteId}
        siteName={siteName}
      />
      <DisableMsTeamsModal
        isOpen={disconnectModalOpen}
        onRequestClose={() => setDisconnectModalOpen(false)}
        onSuccess={() => setDisconnectModalOpen(false)}
        onError={() => setDisconnectModalOpen(false)}
        siteId={siteId}
        siteName={siteName}
      />
    </>
  );
};
